import { render, staticRenderFns } from "./PartnerAccounting.vue?vue&type=template&id=cf564934&scoped=true"
import script from "./PartnerAccounting.vue?vue&type=script&lang=ts"
export * from "./PartnerAccounting.vue?vue&type=script&lang=ts"
import style0 from "./PartnerAccounting.vue?vue&type=style&index=0&id=cf564934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf564934",
  null
  
)

export default component.exports